import React from 'react';
import { LeadData } from '../../../src/types';

const MoreInfoSection: React.FC<{ lead: LeadData }> = ({ lead }) => {
  return (
    <div
      className="mt-6 bg-gray-100 dark:bg-gray-800 text-gray-800 dark:text-gray-100 border border-gray-300 dark:border-gray-600 shadow-sm p-4 rounded-lg transition-colors duration-300"
      style={{ fontFamily: 'Lato, sans-serif', fontWeight: 'normal' }}
    >
      <h3 className="text-lg font-semibold mb-4 text-gray-800 dark:text-white/90">More Information</h3>

      <div className="grid grid-cols-1 md:grid-cols-3 gap-4">
        <div>
          <strong className="text-sm font-medium text-gray-500 dark:text-gray-400">
            Company Name
          </strong>
          <p className="text-theme-sm text-black dark:text-white">{lead.company_name || 'N/A'}</p>
        </div>

        <div>
          <strong className="text-sm font-medium text-gray-500 dark:text-gray-400">
            Company Website
          </strong>
          <p className="text-theme-sm text-black dark:text-white">{lead.company_website || 'N/A'}</p>
        </div>

        <div>
          <strong className="text-sm font-medium text-gray-500 dark:text-gray-400">
            Referred By
          </strong>
          <p className="text-theme-sm text-black dark:text-white">{lead.referred_by || 'N/A'}</p>
        </div>
      </div>

      <div className="mt-4">
        <strong className="text-sm font-medium text-gray-500 dark:text-gray-400">
          Description
        </strong>
        <p
          className="text-theme-sm text-black dark:text-white text-justify"
          style={{ textAlign: 'justify' }}
        >
          {lead.description || 'N/A'}
        </p>
      </div>
    </div>
  );
};

export default MoreInfoSection;
